// extracted by mini-css-extract-plugin
export var hidden = "_ts-0";